const state = () => ({
  otherVerticalSubs: {},
});

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
};

const actions = {
  async getOtherVerticalSubs({ commit }, { vertical }) {
    const body = {
      method: "GET",
      url: `${this.$config.baseURL}/api/${vertical}/user-subscriptions`,
    };
    return await this.$axios(body)
      .then(({ data }) => {
        commit("setData", {
          label: "otherVerticalSubs",
          data: { [vertical]: data },
        });
      })
      .catch(({ response }) => {
        console.warn(response, vertical);
      });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
